/* eslint-disable react/destructuring-assignment */
import React from 'react';
import PropTypes from 'prop-types';
import Loading from '../Loader';

/**
 * Async component use to display a Loading component while loading a component through a promise.
 *
 */
class Async extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  /**
   * update when promise completes.
   */
  componentWillMount() {
    this.cancelUpdate = false;
    if (!this.state.component) {
      this.props.promise.then((c) => {
        if (!this.cancelUpdate) {
          this.setState({ component: c.default || c });
        }
      });
    }
  }

  /**
   * Cancel promise completion.
   * update when promise completes.
   */
  componentWillUnmount() {
    this.cancelUpdate = true;
  }

  /**
   * Render either Loading or loaded component.
   */
  render() {
    const { promise, loading, className, classNameLoader, loaderSize, ...otherProps } = this.props;
    if (!this.state.component) {
      return loading || (<Loading classNameLoader={`${classNameLoader} loading`} size={loaderSize} />);
    }
    // <Loading classNameLoader={`${classNameLoader} loading`} {...otherProps} size={loaderSize} />;
    return (<this.state.component className={className} {...otherProps} />);
  }
}

Async.propTypes = {
  promise: PropTypes.instanceOf(Promise).isRequired,
  loading: PropTypes.element,
  className: PropTypes.string,
  classNameLoader: PropTypes.string,
  loaderSize: PropTypes.number,
};

Async.defaultProps = {
  loading: null,
  loaderSize: 2.1,
  classNameLoader: '',
  className: '',
};
export default Async;
